import { render, staticRenderFns } from "./LoadingSkeleton.vue?vue&type=template&id=65a052ba&"
import script from "./LoadingSkeleton.vue?vue&type=script&lang=js&"
export * from "./LoadingSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./LoadingSkeleton.vue?vue&type=style&index=0&id=65a052ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports